import React from 'react';
import styles from './AuthBetweenLink.module.scss';
import { Link } from 'react-router-dom';

interface Props {
  title: string,
  link: string,
  linkText: string
}

function AuthBetweenLink(props: Props) {
  const { title, link, linkText } = props;
  return (
    <div className={styles.container}>
      <span>{title}&nbsp;</span>
      <Link to={link}><span className={styles.link}>{linkText}</span></Link>
    </div>
  )
}

export default AuthBetweenLink;
